import type { InputValue } from '@/types/node-types';

/**
 * Whether a value would still fail a required-field check: the same rules
 * `validateFields` applies per input type, folded into one test so a writer
 * can tell a real value from a blank one without knowing the field's type.
 */
export function isBlankValue(value: InputValue | unknown): boolean {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') return value.trim() === '';
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
}
